// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33rHy","left":"styles_left__3YX6j"};